import React, { useEffect, useState } from 'react';

const SplashScreen = () => {
  const [phase, setPhase] = useState('visible');

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('shrinking'), 1500);
    const t2 = setTimeout(() => setPhase('done'), 2500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (phase === 'done') return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-emerald-950/85 backdrop-blur-md transition-opacity duration-700"
      style={{ opacity: phase === 'shrinking' ? 0 : 1 }}
    >
      <img
        src="/solvida-logo-new.png"
        alt=""
        className="transition-all duration-1000 ease-in-out"
        style={{
          width: phase === 'visible' ? '420px' : '64px',
          opacity: phase === 'visible' ? 1 : 0,
          transform: phase === 'visible' ? 'scale(1)' : 'scale(0.3) translateY(-40vh) translateX(-40vw)',
        }}
      />
    </div>
  );
};

export default SplashScreen;
